import { render } from "./NumericField.vue?vue&type=template&id=640f361f&scoped=true"
import script from "./NumericField.vue?vue&type=script&lang=js"
export * from "./NumericField.vue?vue&type=script&lang=js"

import "./NumericField.vue?vue&type=style&index=0&id=640f361f&lang=scss"
import "./NumericField.vue?vue&type=style&index=1&id=640f361f&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-640f361f"]])

export default __exports__